// eslint-disable-next-line
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'
// import Home from '@/layout'
import Login from '@/views/Login.vue'
// 公有权限列表
export const publicRouter = [
  {
    path: '/',
    redirect: '/home/userInfo'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home,

    meta: {
      title: '系统首页',
      icon: 'House'
    },
    children: [
      {
        path: '/home/userInfo',
        name: '个人中心',
        component: () => import('../views/user/UserInfo.vue'),
        meta: {
          title: '个人中心',
          icon: ''
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: "/",
    meta: {
      show: false
    }
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes: publicRouter
})

export default router
